export default {
  public_layout: {
    login: 'Connexion',
    cookies: {
      title: 'Utilisation des cookies',
      text: 'SorareMega utilise des cookies pour collecter des données afin de vous fournir la meilleure expérience utilisateur possible',
      learn_more: 'Pour en savoir plus, vous pouvez lire notre',
      privacy_policy: 'Politique de confidentialité',
      accept: 'Accepter',
      decline: 'Refuser',
    },
  },
  home: {
    enter_the_arena: 'Entrez dans l\'Arène',
    leagues_score_dice_cups: 'Ligues • Score Dice • Coupes',
    start_playing_now: 'Jouez maintenant',
  },
  login: {
    login_with_sorare: 'Connectez-vous avec votre compte Sorare',
    dont_have_sorare_account: 'Pas de compte Sorare?',
    create_one_now: 'Créez en un maintenant',
  },
  coming_soon: {
    soraremega_will_come_back_soon: 'SorareMega revient bientôt',
    enter_email: 'Entrez votre email pour rester informé et recevoir les dernières nouvelles',
    submit: 'Envoyer',
    success_message: 'Merci pour votre inscription',
  },
  nav: {
    help: 'Aide',
    logout: 'Déconnexion',
  },
  manager_profile: {
    gallery: 'GALERIE',
  },
  mega_league_result: {
    my_fixture: 'Mon match',
    leaderboard: 'Classement',
    fixtures: 'Matchs',
    no_fixture_for_this_gw: 'Pas de match',
  },
  beta_tester: {
    only_for_beta_tester: 'Seulement pour les beta testeur',
  },
  game_week: {
    ended: 'TERMINÉ',
    waiting: 'EN ATTENTE',
    live: 'EN DIRECT',
    open: 'OUVERT',
  },
  lobby: {
    play: 'Jouer',
    edit: 'Éditer',
    live_results: 'En direct',
    results: 'Résultats',
  },
  filter_menu: {
    filter: 'Filtre',
    playing_this_gw: 'Jouant cette GW',
    show_last_5_score: 'Afficher les 5 derniers scores',
  },
  filter_drawer: {
    sort_by: 'Trier par',
    scarcity: 'Rareté',
    position: 'Position',
    last_recruits: 'Dernières recrues',
    name: 'Nom',
    unique: 'Unique',
    super_rare: 'Super-rare',
    rare: 'Rare',
    limited: 'Limited',
    forward: 'Attaquant',
    midfielder: 'Milieu',
    defender: 'Défenseur',
    goalkeeper: 'Gardien',
  },
  formation: {
    formation: 'Formation',
  },
  status: {
    confirmed: 'Confirmé',
    not_confirmed: 'Non confirmé',
    confirm: 'Confirmer',
    cancel: 'Annuler',
  },
  card_picker: {
    no_card_picked: 'Aucune carte choisie',
  },
  pick_card_dialog: {
    player_pick: 'Choix du joueur',
  },
  first_login_dialog: {
    settings : 'Paramètres',
    email_address : 'Adresse email',
    save : 'Enregistrer',
    invalid_email : 'Email invalide',
  },
  user_lineup_dialog:{
    unable_to_load_lineup: 'Impossible de charger l\'équipe',
  },
  lineup_header:{
    average_per_free_position: 'Moyenne par position libre :',
  },
  stats: {
    yellow_card: 'Carton jaune',
    foul: 'Faute',
    was_fouled: 'Faute subie',
    error_lead_to_shot: 'Erreur amenant un tir',
    clean_sheet: 'Clean sheet',
    goal_conceded: 'But encaissé',
    effective_clearance: 'Dégagement réussi',
    won_tackle: 'Tacle réussi',
    blocked_cross: 'Centre bloqué',
    outfielder_block: 'Blocage d\'un joueur de champ',
    possession_lost: 'Ballon perdu',
    possession_won: 'Ballon gagné',
    duel_lost: 'Duel perdu',
    duel_won: 'Duel gagné',
    interception_won: 'Interception réussie',
    big_chance_created: 'Grosse occasion créée',
    attempted_assist: 'Dernière passe amenant un tir',
    accurate_pass: 'Passe réussie',
    accurate_final_third_pass: 'Passe réussie dans le dernier tiers',
    accurate_long_ball: 'Long ballon réussi',
    accurate_own_to_opposite_pass: 'Passe longue dans le camp adverse',
    missed_pass: 'Passe ratée',
    shot_on_target: 'Tir cadré',
    won_contest: 'Dribble réussi',
    penalty_area_entry: 'Incursion dans la surface',
    penalty_kick_missed: 'Pénalty manqué',
    big_chance_missed: 'Grosse occasion ratée',
    save: 'Arrêt',
    saved_shot_from_inside_box: 'Sauvetage dans la surface',
    good_high_claim: 'Centre capté',
    punch: 'Dégagement aux poings',
    dive_save: 'Arrêt plongeon',
    dive_catch: 'Arrêt plongeon capté',
    cross_not_claimed: 'Centre non dégagé',
    six_second_violation: 'Règle des six secondes',
    gk_smother: 'Balle captée',
    keeper_sweeper: 'Sortie réussie',
  },
  splitted_score: {
    decisive: 'Décisif',
    all_around: 'Complet',
  },
  snackbar: {
    team_successfully_confirmed: 'Équipe confirmée avec succès',
    duplicated_card: 'Carte dupliquée',
    duplicated_player: 'Joueur dupliqué',
    invalid_captain: 'Capitaine invalide',
    missing_captain: 'Capitaine manquant',
    invalid_formation: 'Formation invalide',
    invalid_ownership: 'Propriété invalide',
    invalid_position: 'Position invalide',
    invalid_scarcity: 'Rareté invalide',
    invalid_edition: 'Édition invalide (légende)',
    goalkeeper_required: 'Gardien requis',
    invalid_goalkeeper: 'Gardien invalide',
    invalid_defenders: 'Défenseurs invalides',
    invalid_midfielders: 'Milieux invalides',
    invalid_forwards: 'Attaquants invalides',
    team_canceled: 'Équipe annulée',
    cap_exceeded: 'Plafond dépassé',
    max_players_per_team: 'Trop de joueurs de la même équipe, maximum 3 autorisé'
  },
  mega_league: {
    tabs: {
      my_team: 'Mon équipe',
      leaderboard: 'Classement',
    }
  }
};
